export default function () {
    return {
        // copyright: `${websiteName}创新应用项目 ${productName}注册服务中`,
        copyright: `人工智能+创新应用服务平台 人工智能商城注册服务中心`,
        record: '京ICP备18024298号-53',
        concat: '400-652-1008/010-53607985',
        company: {
            // name: `${websiteName}创新应用项目 ${productName}注册服务中心`,
            name: `北京国信诚商互联网科技有限公司`,
            address: '北京市丰台区科技园郭公庄北京方向大厦A座1310室'
        },
        // 主办单位
        sponsor: '北京国信诚商互联网科技有限公司'
    }
}